<template>
  <div class='hf fl' style='align-Items: top;'>
    <div class='timeline-date-container'>
      <slot name='left' />
    </div>

    <div class='timeline-element-container'>
      <svg width='20' class='timeline-element'>
      <defs>
        <linearGradient id='timeline-element-gradient-vertical'
          y1='0' y2='1' x1='0' x2='0'>
          <stop offset="5%" stop-color="#00b981"/>
          <stop offset="95%" stop-color="#008BAE" />
        </linearGradient>
      </defs>
        <line v-if="!final" y1='6' y2='105%' x1='8' x2='8.000001' :class="lineClass()" />
        <circle cx='8' cy='13.5' r='6' :class="circleClass()" />
      </svg>
    </div>

    <div class='timeline-slot-container'>
      <slot name='right' />
    </div>
  </div>
</template>

<script>
export default {
  /* Draw a AEV Timeline Element with corresponding container */
  name: 'TimelineElementContainer',
  props: {
    date: String,
    // Circles
    primary: Boolean,
    secondary: Boolean,
    // Color
    blue: Boolean,
    green: Boolean,
    fade: Boolean,

    final: Boolean
  },
  methods: {
    circleClass () {
      let result = 'circle ';

      if (this.primary) result += 'primary ';
      else result += 'secondary ';

      if (this.green) result += 'green ';
      else result += 'blue ';

      return result;
    },
    lineClass () {
      let result = 'line';

      if (this.fade) result += ' fade';
      else if (this.green) result += ' green';
      else result += ' blue';

      return result;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.timeline-element-container {
  width: 60px;
  height: auto;
  box-sizing: border-box;
}

.timeline-date-container {
  width: 150px;
}

.timeline-slot-container {
  width: 100%;
}

.timeline-element {
  overflow: visible;
  display: block;
  height: 100%;

  .line {
    stroke-width: 4;
    &.fade { stroke: url(#timeline-element-gradient-vertical); }
    &.blue { stroke: $secondary; }
    &.green { stroke: $positive; }
  }

  .circle {
    &.primary {
      &.blue {
        stroke: $secondary;
        stroke-width: 4;
        fill: white;
      }

      &.green {
        stroke: $positive;
        stroke-width: 4;
        fill: white;
      }
    }

    &.secondary {
      &.blue {
        stroke: white;
        stroke-width: 4;
        fill: $secondary;
      }
      &.green {
        stroke: white;
        stroke-width: 4;
        fill: $positive;
      }
    }
  }
}
</style>
